// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"Topbar_compWrap__-BS0n","text":"Topbar_text__2Rlbd"};